<template>
    <div class="step step-4">
        <div class="stepWrap">
            <div class="wrap">
                <p>{{ 'components/Login/multiple-accounts.you-have-multiple-accounts' | trans}}</p>
                <div class="accounts">
                    <div v-for="(user, i) in accountsData" class="account">
                        <input v-model.number="account" type="radio" name="account" :id="i" :value="i">
                        <label :for="i" class="account">
                            <h4>{{ user.name }}</h4>
                            <p>{{ user.account_type }}<br/>
								{{'components/Login/multiple-accounts.outstanding' | trans}}: {{ user.account_balance }}
                                <br/>{{'components/Login/multiple-accounts.active-from' | trans}}: {{ user.account_active_from }}
                                <br/>{{'components/Login/multiple-accounts.account-reference' | trans}}: {{ user.account_reference }}</p>
                        </label>
                    </div>
                    <div v-if="accountSelectedError" class="error">{{'components/Login/multiple-accounts.select-account' | trans}}</div>
                </div>
            </div>
        </div>
        <div class="submitButton">
            <ButtonWithLoading
                classes="btn btn-block"
                :loading="loginLoading"
                @click="submitUser"
                :title="'components/Login/multiple-accounts.continue' | trans"
            />
            <a @click="logout" :class="[$mq=='sm' ? 'btnThree' : 'back' ]" href="#">{{'components/Login/multiple-accounts.logout' | trans}}</a>
        </div>
    </div>
</template>

<script>
    import helper from '../../services/helper';
    import ButtonWithLoading from '../form/ButtonWithLoading';

    export default {
        props: {
            accountsData: {
                type: Array
            }
        },
        data() {
            return {
                account: '',
                accountSelectedError: false,
                loginLoading: false
            }
        },
        components: {
            ButtonWithLoading
        },
        methods: {
            submitUser() {


                if (this.account === '') {
                    return this.accountSelectedError = true;
                }

                this.loginLoading = true;
                this.loginLoading = false;
                this.$store.dispatch('saveUserData', {user: this.accountsData[this.account]})
                    .then(() => axios.post('/api/auth/set-selected-account', { account: this.accountsData[this.account].loan }))
					.then(()=> this.$store.dispatch('getDocuments'))
					.then(() => this.$router.push('/'));

            },
            logout(e) {
                e.preventDefault();
                helper.logout().then(() => {
                    window.location.reload();
                });
            },
        },
        watch: {
            accountSelectedError: function () {
                if (this.account) {
                    this.accountSelectedError = false;
                }
            }
        }
    }
</script>

<style scoped>
    .error {
        margin-top: 3px;
        margin-bottom: 10px;
        color: #FF6044;

    }
</style>
